<template>
  <div class="min-h-screen bg-red-500 flex items-center justify-center">
    <div class="bg-white p-8 rounded-lg shadow-lg">
      <h1 class="text-2xl font-bold text-gray-800 mb-4">Test View</h1>
      <p class="text-gray-600">Si puedes ver esto, Vue está funcionando correctamente.</p>
    </div>
  </div>
</template>

<script setup>
// Simple test component
</script>
